import { apiSlice } from "features/api/apiSlice";

const createAppointment = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    createAppointment: build.mutation({
      query: (body) => ({
        url: "/appointments",
        method: "POST",
        body,
      }),
      transformResponse: (res) => res.d.appointments.id,
      invalidatesTags: (result) => {
        if (result) {
          return [
            { type: "Doctor", id: result.practitioner.id },
            "Appointment",
            "Voucher",
          ];
        }
      },
    }),
  }),
});

export const { useCreateAppointmentMutation } = createAppointment;
